import { WSElement, WSText } from "@wingspanhq/fe-component-library";
import { useUserId } from "../../../query/hooks/helpers";
import { useClientQuery } from "../../../query/users/queries";
import { LabelMethod } from "../../Settings/components/LabelMethod";
import { useDefaultPaymentMethod } from "../../Settings/components/payment/DefaultPaymentMethod";
import styles from "./EmbeddedDefaultPaymentMethod.module.scss";

export const EmbeddedDefaultPaymentMethod = () => {
  const userId = useUserId();
  const queryClient = useClientQuery(userId);
  const defaultPaymentMethod = useDefaultPaymentMethod();

  if (queryClient.isLoading) {
    return <WSElement shimmer className={styles.shimmer} />;
  }

  if (!defaultPaymentMethod.type || !defaultPaymentMethod.id) {
    return <WSText color="gray400">No payment method set</WSText>;
  }

  return (
    <LabelMethod
      type={defaultPaymentMethod.type}
      id={defaultPaymentMethod.id}
    />
  );
};
